import { Flex, Spacer, Tabs, Grid } from '@percent/lemonade'
import styles from './DonationFormPage.module.scss'
import { DonationPageHeader } from './DonationPageHeader'
import { ShareableLinkTab } from './ShareableLinkTab'
import { EmbeddedSnippetTab } from './EmbeddedSnippetTab'
import { useState, useRef, useEffect } from 'react'
import { DonationFormPageHeaderKey } from './DonationFormPage.types'
import { t } from 'i18next'

export const NewDonationFormPage = () => {
  const [activeTab, setActiveTab] = useState<DonationFormPageHeaderKey>(DonationFormPageHeaderKey.SHAREABLE_LINK)
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    setActiveTab(DonationFormPageHeaderKey.SHAREABLE_LINK)
  }, [])

  const tabs = [
    {
      key: DonationFormPageHeaderKey.SHAREABLE_LINK,
      label: t('donationForm.headerTab.shareableLink.title')
    },
    {
      key: DonationFormPageHeaderKey.EMBEDDED_SNIPPET,
      label: t('donationForm.headerTab.embedSnippet.title')
    }
  ]

  const renderTabContent = () => {
    switch (activeTab) {
      case DonationFormPageHeaderKey.SHAREABLE_LINK:
        return <ShareableLinkTab />
      case DonationFormPageHeaderKey.EMBEDDED_SNIPPET:
        return <EmbeddedSnippetTab />
      default:
        return null
    }
  }

  return (
    <Flex direction={{ xs: 'column', md: 'row' }} h="100%" gap="sm" p="0" justify="space-between">
      <Grid className={styles.gridContainer} columns={12}>
        <Grid.Col span={{ md: 8 }}>
          <div className={styles.container}>
            <DonationPageHeader activeTab={activeTab} setActiveTab={setActiveTab} />
            <Tabs
              items={tabs}
              activeTab={activeTab}
              onChangeTab={tab => setActiveTab(tab as DonationFormPageHeaderKey)}
            />
            <Spacer size="m" axis="horizontal" />
            {renderTabContent()}
          </div>
        </Grid.Col>
        <Grid.Col className={styles.videoGridItem} span={{ md: 'auto' }}>
          <div className={styles.videoContainer}>
            <video
              ref={videoRef}
              src="/assets/videos/HDGWTour.mp4"
              data-testid="hdgw-tour-video"
              controls
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              className={styles.video}
            />
          </div>
        </Grid.Col>
      </Grid>
    </Flex>
  )
}
